<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-info"></i>
          Export ບິນທັງໝົດ
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>

    </div>
    <div class="box">
      <div class="columns is-multiline">
        <div class="column is-2">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">
              ປະເພດບິນ
            </label>
            <div class="select">
              <select class="input" v-model="type">
                <option v-if="!$can('service')" value="created">ຍອດສ້າງ</option>
                <option v-if="!$can('service')" value="arrived">ຮອດສາຂາປາຍທາງ</option>
                <option v-if="!$can('service')" value="success">ຈັດສົ່ງສຳເລັດ</option>
                <option value="remained">ເຄື່ອງຄ້າງ</option>
                <option v-if="!$can('service')" value="lost">ເຄື່ອງເສຍ</option>
                <option v-if="!$can('service')" value="reject">ເຄື່ອງຕິກັບ</option>
                <option v-if="!$can('service')" value="dispose">ທຳລາຍ</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="!$can('service')" class="column is-2">
          <div class="control">
            <label class="label">
              ປະເພດລູກຄ້າ
            </label>
            <div class="select">
              <select class="input" v-model="customer_type">
                <option value="all">ທັງໝົດ</option>
                <option value="vip">ລູກຄ້າ VIP</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">ສາຂາຕົ້ນທາງ:</label>
            <model-list-select
                :list="branchOptions"
                v-model="start_branch_id"
                option-text="name"
                option-value="id"
                selectedItem="name"
                placeholder="ທັງໝົດ">
            </model-list-select>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <label class="label">ສາຂາປາຍທາງ:</label>
            <model-list-select
                :list="branchOptions"
                v-model="end_branch_id"
                option-text="name"
                option-value="id"
                selectedItem="name"
                placeholder="ທັງໝົດ">
            </model-list-select>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">&nbsp;</label>
            <button
                type="button"
                class="button"
                :class="{'is-loading': loading}"
                :disabled="loading"
                @click="printSummaryBranch()">
              export excel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ວັນທີສ້າງ</vs-th>
            <vs-th>ຊື່</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="branch"
              v-for="(branch, index) in $vs.getPage(listPrint, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ moment(branch.created_at).format('DD-MM-YYYY HH:mm') }}</vs-td>
            <vs-td>{{ branch.name }}</vs-td>
            <vs-td>{{ laStatus[branch.status] }}</vs-td>
            <vs-td style="text-align: right; width: 100px">
              <div class="group-icon">
                <div v-if="branch.status === 1">
                  <vs-button circle icon flat @click="download(branch.id, branch.name)">
                    <i class="fal fa-download"></i>
                  </vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/Pagination';
import * as helper from "@/Helpers/GetValue";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import can from "@/Helpers/Can";
import {ModelListSelect} from "vue-search-select";

export default {
  components: {
    Loading,
    pagination,
    DatePicker,
    ModelListSelect
  },

  data: () => ({
    laStatus: {
      0: 'ກຳລັງດຳເນີນການ',
      1: 'ສຳເລັດ'
    },
    page: 1,
    max: 10,
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    branch: '',
    branches: [],
    searchItem: "",
    oldVal: "",
    listPrint: [],
    // Pagination
    count: 0,
    type: can('service') ? 'remained' : 'created',
    customer_type: 'all',
    start_branch_id: '',
    end_branch_id: '',
    branchOptions: [],
    offset: 10,
    limit_page: 10,
    pagination: {},

    //Export
    actualSelectedItems: [],
    isSelecting: false,
    pageInvoices: [],
    loading: false,
    checkedAll: false,
  }),
  methods: {
    download(id, filename) {
      this.$http.get(`download/all/shipment/export/${id}`, {responseType: 'blob'})
          .then((response) => {
            const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileUrl
            fileLink.setAttribute('download', filename)
            document.body.appendChild(fileLink)
            fileLink.click()
            document.body.removeChild(fileLink)
          }).catch((e) => console.log(e))
    },
    printSummaryBranch() {
      const loading = this.BtnLoading();
      this.loading = true;
      this.$http.post('/print/all/shipment', {
        type: this.type,
        customer_type: this.customer_type,
        start_date: this.start_date,
        end_date: this.end_date,
        start_branch_id: this.start_branch_id || null,
        end_branch_id: this.end_branch_id || null,
      }).then(() => {
        setTimeout(() => {
          this.loading = false;
          loading.close();
          this.FetchData();
        }, 500);
      }).catch(() => {
        this.loading = false;
        loading.close()
      });
    },

    // printSummaryBranch() {
    //   const loading = this.BtnLoading();
    //   this.loading = true;
    //   this.$http.post('/print/all/shipment', {
    //     start_date: this.start_date,
    //     end_date: this.end_date,
    //   }, {responseType: 'blob'}).then((res) => {
    //     const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
    //     const fileLink = document.createElement('a');
    //     fileLink.href = fileUrl;
    //     if (this.start_date === this.end_date) {
    //       fileLink.setAttribute('download', 'ລາຍການແລກຂອງລາງວັນທີ ' + moment(this.start_date).format('DD-MM-YYYY') + '.xlsx');
    //     } else {
    //       fileLink.setAttribute('download', 'ລາຍການແລກຂອງລາງວັນທີ ' + moment(this.start_date).format('DD-MM-YYYY') + 'ຫາ' + moment(this.end_date).format('DD-MM-YYYY') + '.xlsx');
    //     }
    //     document.body.appendChild(fileLink);
    //     fileLink.click();
    //     document.body.removeChild(fileLink);
    //     this.loading = false;
    //     loading.close()
    //   }).catch(() => {
    //     this.loading = false;
    //     loading.close()
    //   });
    // },

    FormatPrice(price) {
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    disableDateCustomer(date) {
      const fixDay = moment('2021-08-01 00:00:00');
      return date < fixDay;
    },
    FetchData() {
      this.isLoading = true;
      this.fetchInvoiceItemsResponse().then((res) => {
        setTimeout(() => {
          this.listPrint = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchInvoiceItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('list/print/summary/branch', {
        params: {
          page: current_page ?? this.pagination.current_page,
          per_page: per_page ?? this.limit_page,
        }
      })
    },
    FetchBranches() {
      this.$http.get('v1/listing/branches').then((res) => {
        this.branchOptions = [
          {id: '', name: 'ທັງໝົດ'},
          ...res.data.map((item) => ({id: item.id, name: `${item.prefix}-${item.name}`}))
        ];
      }).catch(() => {});
    },
    FilterBySearch() {
      helper.GetOldValueOnInput(this);
    },
    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
  created() {
    this.FetchData();
    this.FetchBranches();
  }
};
</script>
<style lang="scss" scope>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}

</style>
